import React, { useState } from 'react'
import { Card, Input, Button } from 'antd'
import axios from 'axios'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { changePasswordAdmin } from '../../../AllAPI/AdminAPI'

const ChangePasswordAdmin = () => {
  const navigate = useNavigate()

  const adminId = sessionStorage.getItem('admin_id')
  const username = sessionStorage.getItem('username')

  const [loading, setLoading] = useState(false)

  const [formData, setFormData] = useState({
    old_password: '',
    new_password: '',
    confirm_password: '',
  })

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }

  const handleSubmit = async () => {
    if (
      !formData.old_password ||
      !formData.new_password ||
      !formData.confirm_password
    ) {
      toast.warning('Please fill all fields')
      return
    }

    if (formData.new_password !== formData.confirm_password) {
      toast.warning('New Password and Confirm Password must be same')
      return
    }

    try {
      setLoading(true)

      const payload = {
        admin_id: Number(adminId),
        old_password: formData.old_password,
        new_password: formData.new_password,
      }

      const { data } = await axios.put(`${changePasswordAdmin}`, payload)

      switch (data) {
        case 'CHANGED_PASSWORD':
          toast.success('Password changed successfully.')

          setFormData({
            old_password: '',
            new_password: '',
            confirm_password: '',
          })

          navigate(-1)
          break

        case 'ADMIN_NOT_FOUND':
          toast.error('Admin not found.')
          break

        case 'INVALID_CREDENTIALS':
          toast.error('Old password is incorrect.')
          break

        case 'NEW_PASSWORD_REQUIRED':
          toast.warning('Please enter a new password.')
          break

        case 'SAME_PASSWORD_NOT_ALLOWED':
          toast.warning('New password cannot be the same as the old password.')
          break

        default:
          toast.error('Something went wrong.')
      }
    } catch (error) {
      toast.error('Server error. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-5">
          <Card title="Change Password">
            <div className="mb-3">
              <label>Old Password</label>
              <Input.Password
                name="old_password"
                value={formData.old_password}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label>New Password</label>
              <Input.Password
                name="new_password"
                value={formData.new_password}
                onChange={handleChange}
              />
            </div>

            <div className="mb-4">
              <label>Confirm Password</label>
              <Input.Password
                name="confirm_password"
                value={formData.confirm_password}
                onChange={handleChange}
              />
            </div>

            <div className="d-flex justify-content-end gap-2">
              <Button onClick={() => navigate(-1)}>Cancel</Button>

              <Button type="primary" loading={loading} onClick={handleSubmit}>
                Change Password
              </Button>
            </div>
          </Card>
        </div>
      </div>
    </div>
  )
}

export default ChangePasswordAdmin
